import { gql } from '@apollo/client'

const GET_GOOGLE_PLACE_DETAILS = gql`
  query GET_GOOGLE_PLACE_DETAILS($searchTerm: String!, $companyId: ID) {
    getGooglePlaceDetails(searchTerm: $searchTerm, companyId: $companyId)
  }
`

export default GET_GOOGLE_PLACE_DETAILS
